import { render, staticRenderFns } from "./TERYTForm.vue?vue&type=template&id=72ca1e15"
import script from "./TERYTForm.vue?vue&type=script&lang=js"
export * from "./TERYTForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports